import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicRoutingModule } from './public-routing.module';
import { PageNotFoundComponent } from './pages/page-not-found.component';
import { LoginModule } from './login/login.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PublicRoutingModule,
    LoginModule
  ],
  declarations: [PageNotFoundComponent]
})
export class PublicModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/public/public.module.ts